// GENERATED FILE — do not edit by hand.
// Written by scripts/generate-catalogue-stats.js during prebuild.
//
// These are the counts shown in the home page trust band. They are generated so
// they cannot drift from the catalogue: the band previously read "20+ Certified
// Courses" against 61 real ones.
export const CATALOGUE_STATS = {
  courses: 61,
  assessments: 10,
};

// Courses in a promoted cohort (those carrying a `waitlist` block), cheapest
// first. Session dates are raw ISO strings on purpose: src/components/CohortBand
// filters them against the current time on every render, so a cohort that has
// finished disappears from the home page without needing a rebuild.
export const COHORT_COURSES = [
  {
    "slug": "prompt-engineering-basics",
    "title": "Prompt Engineering Basics: Get the Best Out of Your AI Tools",
    "audience": "Two evening hours that turn vague AI answers into usable work",
    "priceAud": 195,
    "isFree": false,
    "promoCode": null,
    "promoPercentOff": null,
    "cohortLabel": "Next cohort",
    "sessions": [
      "2026-09-21T18:00:00+10:00",
      "2026-09-28T18:00:00+10:00",
      "2026-10-05T18:00:00+11:00"
    ]
  },
  {
    "slug": "ai-quick-start-hr",
    "title": "AI Quick Start for HR Teams",
    "audience": "One evening of practical AI for the documents HR writes every week",
    "priceAud": 395,
    "isFree": false,
    "promoCode": null,
    "promoPercentOff": null,
    "cohortLabel": "Next cohort",
    "sessions": [
      "2026-09-22T18:00:00+10:00",
      "2026-09-29T18:00:00+10:00",
      "2026-10-06T18:00:00+11:00"
    ]
  },
  {
    "slug": "ai-quick-start-executive-assistants",
    "title": "AI Quick Start for Executive Assistants",
    "audience": "One evening of practical AI for inbox, calendar, briefings, and travel",
    "priceAud": 395,
    "isFree": false,
    "promoCode": null,
    "promoPercentOff": null,
    "cohortLabel": "Next cohort",
    "sessions": [
      "2026-09-23T18:00:00+10:00",
      "2026-09-30T18:00:00+10:00",
      "2026-10-07T18:00:00+11:00"
    ]
  },
  {
    "slug": "ai-quick-start-small-business",
    "title": "AI Quick Start for Small Business Owners",
    "audience": "One evening of practical AI for quotes, customers, marketing, and admin",
    "priceAud": 395,
    "isFree": false,
    "promoCode": null,
    "promoPercentOff": null,
    "cohortLabel": "Next cohort",
    "sessions": [
      "2026-09-24T18:00:00+10:00",
      "2026-10-01T18:00:00+10:00",
      "2026-10-08T18:00:00+11:00"
    ]
  }
];

// Minimal card data for src/components/TrainingCertifications. Keeping this
// generated slice here prevents the landing page from importing all courses.
export const FEATURED_COURSES = [
  {
    "slug": "copilot-wave-3-agentic-ai",
    "title": "Microsoft 365 Copilot Wave 3 & Agentic AI for Australian IT Leaders",
    "duration": "8 hours",
    "students": "New",
    "level": "Intermediate",
    "image": "https://cdn.educ4te.com/courses/course-1.webp?v=20260102"
  },
  {
    "slug": "purview-for-copilot",
    "title": "Purview for AI Governance (DSPM)",
    "duration": "8 hours",
    "students": "New",
    "level": "Advanced",
    "image": "https://cdn.educ4te.com/courses/course-2.webp?v=20260102"
  },
  {
    "slug": "sharepoint-copilot-in-a-day",
    "title": "SharePoint Copilot Governance — SAM, RCD and Permission Remediation",
    "duration": "8 hours",
    "students": "New",
    "level": "Intermediate",
    "image": "https://cdn.educ4te.com/courses/course-3.webp?v=20260102"
  }
];
